// extracted by mini-css-extract-plugin
export default {"price":"Y6-z","onSale":"Z6-z","msrpLabelPrice":"_6-z","msrpLabel":"a7-z","originalPrice":"b7-z","percentOff":"c7-z"};